
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerClass()
    export class IcStockApproveDisassembleDtDialog extends Serenity.EntityDialog<IcStockApproveDisassembleDtRow, any> {
        protected getFormKey() { return IcStockApproveDisassembleDtForm.formKey; }
        // protected getIdProperty() { return IcStockApproveDisassembleDtRow.idProperty; }
        protected getLocalTextPrefix() { return IcStockApproveDisassembleDtRow.localTextPrefix; }
        protected getNameProperty() { return IcStockApproveDisassembleDtRow.nameProperty; }
        // protected getService() { return IcStockApproveDisassembleDtService.baseUrl; }
        // protected getDeletePermission() { return IcStockApproveDisassembleDtRow.deletePermission; }
        // protected getInsertPermission() { return IcStockApproveDisassembleDtRow.insertPermission; }
        // protected getUpdatePermission() { return IcStockApproveDisassembleDtRow.updatePermission; }

        protected form = new IcStockApproveDisassembleDtForm(this.idPrefix);

    }
}